<template>
  <SpPage :title="isUpdate() ? '予約変更' : '新規予約'">
    <h2 class="title-done" :class="{ 'is-modify': isUpdate() }">
      <span>予約{{ isUpdate() ? 'を変更' : 'が完了' }}しました</span>
    </h2>

    <div class="histories">
      <ReserveDiff
        v-for="(history, index) in histories"
        :key="index"
        :after="history"
        :before="index === 0 && histories.length > 1 ? histories[index + 1] : null"
      />
    </div>
    <div class="today-reserve-list">
      <Button @click="reserveDay(today)">本日の予約を確認</Button>
    </div>
    <template #footer>
      <Button @click="edit">予約変更</Button>
      <Button primary @click="reserveDay(histories[0].reserveDatetime.date)">予約を確認</Button>
    </template>
  </SpPage>
</template>

<script>
import SpPage from '@/components/templates/SpPage'
import { today } from '@/utils/date'
import ReserveDiff from '@/components/molecules/ReserveDiff'
import Button from '@/components/atoms/Button'
import { mapState } from 'vuex'

export default {
  components: {
    SpPage,
    ReserveDiff,
    Button,
  },
  props: {
    id: Number,
    backTo: String,
  },
  computed: {
    ...mapState({
      histories: state => state.reserves.history.details,
    }),
    today() {
      return today()
    },
  },
  async mounted() {
    const { commit, dispatch } = this.$store
    commit('app/editing', false)
    commit('reserves/edit/reset')
    commit('reserves/history/ended', false)
    await dispatch('reserves/history/get', { rsvId: this.id })
  },
  methods: {
    reserveDay(day) {
      this.$router.push({ name: 'ReserveList', query: { date: day } })
    },
    edit() {
      this.$router.push({ name: 'ReserveEdit', query: { backTo: this.backTo } })
    },
    isUpdate() {
      return this.histories.length > 1
    },
  },
}
</script>

<style lang="postcss" scoped>
.title-done {
  align-items: center;
  display: grid;
  font-size: 48px;
  grid-auto-flow: column;
  justify-content: center;
  margin: 24px 0 32px;

  &::before {
    background: url(/assets/img/icons/done.png) no-repeat;
    background-size: 64px 64px;
    content: '';
    height: 64px;
    margin-right: 16px;
    width: 64px;
  }

  &.is-modify::before {
    background: url(/assets/img/icons/done_modify.png) no-repeat;
    background-size: 64px 64px;
  }

  .responsive & {
    @media screen and (--sp-size) {
      font-size: 24px;
      margin: 16px 0;

      &::before {
        background: url(/assets/img/icons/done.png) no-repeat;
        background-size: 40px 40px;
        height: 40px;
        margin-right: 8px;
        width: 40px;
      }

      &.is-modify::before {
        background: url(/assets/img/icons/done_modify.png) no-repeat;
        background-size: 40px 40px;
      }
    }
  }
}

.histories {
  display: grid;
  grid-gap: 16px 0;
}

.today-reserve-list {
  padding: 16px;

  .button {
    font-size: 15px;
    height: 40px;
    line-height: 40px;
    width: 100%;
  }
}
</style>
